import { render, staticRenderFns } from "./SearchImageCarousel.vue?vue&type=template&id=3b1a67c9&"
import script from "./SearchImageCarousel.vue?vue&type=script&lang=js&"
export * from "./SearchImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b1a67c9')) {
      api.createRecord('3b1a67c9', component.options)
    } else {
      api.reload('3b1a67c9', component.options)
    }
    module.hot.accept("./SearchImageCarousel.vue?vue&type=template&id=3b1a67c9&", function () {
      api.rerender('3b1a67c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8HyQL0UOwUS3s/JS/SearchImageCarousel.vue"
export default component.exports